import { Button } from '@mui/material';
import React, { useState } from 'react';  
import AppBar from '../component/AppBar';

function Counter() {

  const [count, setCount] = useState(0);  


  const add = () => {
    setCount(count + 1);
  };

  const sub = () => {
    setCount(count - 1);
  }; 


  return (
    <div style={{textAlign:"center"}}>
      <AppBar title ='red'/>
      <h1>Music App</h1>
      <h1>Count: {count} </h1>
      <Button sx={{margin:"20px"}} variant='contained' onClick={add}>ADD +1</Button>  
      <Button variant='contained' onClick={sub}>SUB -1</Button>
    </div>
  );
}

export default Counter;
